import moment from 'moment-timezone';
import { useEffect, useMemo, useState } from 'react';
import './OrderTimer.css';

const HOLD_TIMEOUT_HOURS = 48;
const LESS_THAN_MINUTE = 'меньше минуты';

function formatTimeLeft(deadline) {
    const diffSeconds = deadline.diff(moment(), 'seconds');
    if (diffSeconds <= 0) return LESS_THAN_MINUTE;

    const duration = moment.duration(diffSeconds, 'seconds');
    const days = Math.floor(duration.asDays());
    const timePart = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
    return days ? `${days}д ${timePart}` : timePart;
}

function OrderTimer({ order, compact = false }) {
    const [timeLeft, setTimeLeft] = useState(null);

    const isOnlinePayment = order?.payment_type === 'yookassa';
    const isVisible = useMemo(() => (
        order?.status === 'paid'
        && (isOnlinePayment)
        && order?.utc_date
    ), [isOnlinePayment, order?.status, order?.utc_date]);

    const deadline = useMemo(() => {
        if (!isVisible) return null;
        return moment(order.utc_date).add(HOLD_TIMEOUT_HOURS, 'hours');
    }, [isVisible, order?.utc_date]);

    useEffect(() => {
        if (!deadline) {
            setTimeLeft(null);
            return undefined;
        }

        const tick = () => setTimeLeft(formatTimeLeft(deadline));
        tick();

        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [deadline]);

    if (!isVisible) return null;

    const isExpired = timeLeft === LESS_THAN_MINUTE;
    const compactText = isExpired
        ? 'Время истекло, заказ будет отменён автоматически'
        : `Примите решение по&nbsp;оплате в&nbsp;течение ${timeLeft}`;

    return (
        <div
            className={`order-timer ${isExpired ? 'order-timer_expired' : ''} ${compact ? 'order-timer_compact' : ''
                }`}
        >
            {!compact && !isExpired ? (
                <p className="order-timer__title">Платеж заморожен</p>
            ) : null}
            <p className="order-timer__text" dangerouslySetInnerHTML={{
                __html:
                    compact
                        ? compactText
                        : isExpired
                            ? 'Время истекло, заказ будет отменён автоматически'
                            : `Нужно принять решение в&nbsp;течение ${timeLeft}, иначе заказ отменится автоматически`

            }}>

            </p>
        </div>
    );
}

export default OrderTimer;
